import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Row, Col, Image, Modal, Button, Container, Card } from 'react-bootstrap';
import './missing-product_styles.css'
import { OrderContext } from '../../context/OrderContext';
import useProductSet from '../../hook/useProductSet';
import { useNavigate } from 'react-router-dom';
import useCreateRefund from '../../hook/useCreateRefund';
import { FaRegCircleCheck } from "react-icons/fa6";
import useProductsSet from '../../hook/useProductsSet';



const MissingProduct = () => {



  const navigate = useNavigate();
  const {dataProducts} = useCreateRefund()
  const {postProducts} = useProductsSet()

  const [selectedProductIds, setSelectedProductIds] = useState([]);

  const handleToggleCheckbox = (productId) => {
    setSelectedProductIds((prevIds) =>
      prevIds.includes(productId) ? prevIds.filter((id) => id !== productId) : [...prevIds, productId]
    );
  };


  const { orderProduct, process, orderNumber, email} = useContext(OrderContext);


  useEffect(() => {
    if (orderNumber && email) {
      dataProducts(orderNumber, email);
    }
  }, [orderNumber, email]);


  const handleContinue = () => {
    // console.log('Selected Product IDs:', selectedProductIds);
    postProducts(selectedProductIds)
    navigate('/missing-summary-product');
  };

  const map_product = orderProduct?.OrderProducts

  function formatCurrency(amount) {
   
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
  }

  return (
    <>
     <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Row className="w-100 justify-content-center">
          <Col md={6}>
            <ListGroup>
              {map_product?.map((product) => (
                <ListGroup.Item
                  key={product.Id}
                  className="product-card"
                  onClick={() => handleToggleCheckbox(product.Id)}
                >
                  <Row className="g-1 align-items-center row_box">
                    <Col xs={3} md={3} l={3} className="product-image-col">
                      <Image src={product.image} alt={product.Name} className="product-image" />
                    </Col>
                    <Col xs={8} md={8} l={8} className="product-info">
                      <h5 className="product-title">{product.Name}</h5>
                      <p className="product-size-color">Adet: {product.Count}</p>
                      <p className="product-size-color-price">Fiyat: {formatCurrency(product.BasePrice)}</p>
                    </Col>
                    <Col xs={1} md={1} l={1}>
                      {selectedProductIds.includes(product.Id) && (
                        <FaRegCircleCheck size={24} className="check-icon" />
                      )}
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>

        <Row className="w-100 justify-content-center">
          <Col md={6}>
            <Button
              className="mt-3 w-100 transparent-black-button"
              onClick={handleContinue}
              disabled={selectedProductIds.length === 0}
            >
              devam et
            </Button>
          </Col>
        </Row>


    
      </Container>
   
 

  </>
  );
};

export default MissingProduct;
